import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { XCloseIcon } from '@rsos/assets/icons';
import { CloseButton as DCCloseButton } from '@rsos/components/capstone/DataCards/DataCards.styles';
import { Box } from '@rsos/components/capstone/base';
import {
  resetSelectedAirAmbulance,
  setPaneOpen,
} from '@rsos/reduxDataStore/src/features/airAmbulance/airAmbulanceSlice';
import { viewAllCalls } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';
import AgencyShareChatButton from '../../AgencyShareChat/AgencyShareChatButton';
import AirAmbulanceForm from '../../AirAmbulanceForm';
import ScrollShadow from '../../Common/ScrollShadow/ScrollShadow';
import {
  AirAmbulanceStandAlonePane,
  AirAmbulanceStandAlonePaneStyledHeader,
} from './AirAmbulancePane.styles';

export const CloseButton = styled(DCCloseButton)`
  margin-left: 7px;
  height: 20px;
`;

interface AirAmbulancePaneProps {
  onViewJurisdiction: () => void;
}

const AirAmbulancePane = ({
  onViewJurisdiction,
}: AirAmbulancePaneProps): JSX.Element => {
  const dispatch = useDispatch();
  const containerRef = useRef<HTMLDivElement>(null);
  const onClose = async (): Promise<void> => {
    await dispatch(resetSelectedAirAmbulance());
    await dispatch(setPaneOpen(false));
    await dispatch(viewAllCalls());
    onViewJurisdiction();
  };
  return (
    <AirAmbulanceStandAlonePane ref={containerRef}>
      <AirAmbulanceStandAlonePaneStyledHeader data-name="event-pane-header">
        <Box horizontal justify="space-between">
          <Box height={36}>
            <Box paddingTop={1} paddingBottom={1}></Box>
          </Box>
          <Box data-name="event-pane-tools" height={20} horizontal>
            <AgencyShareChatButton />
            {/* <CopyAllButton />
              TODO: waiting for more clarification on what the features entails
             */}

            <CloseButton onClick={onClose}>
              <XCloseIcon />
            </CloseButton>
          </Box>
        </Box>
      </AirAmbulanceStandAlonePaneStyledHeader>
      <AirAmbulanceForm />
      <ScrollShadow containerRef={containerRef} />
    </AirAmbulanceStandAlonePane>
  );
};

export default AirAmbulancePane;
